module.exports = __webpack_public_path__ + "img/ola.76b9cfd5.png";